<template>
  <div>
    <fieldset class="frame">
      <article class="media">
        <div class="media-content">
          <div class="content">
            <h1>{{post.title}}</h1>
            <h3>{{post.name}}</h3>
            <p>{{post.description}}</p>
            <ul class="detail-list">
              <li><span>Stadtteil</span>{{post.district}}</li>
              <li><span>Adresse</span> {{post.address}}</li>
              <li><span>Anfahrt</span>{{post.approach}}</li>
              <li><span>Öffnungszeiten</span>{{post.featured}}</li>
              <li><span>eMail</span>{{post.email}}</li>
              <li><span>Telefon</span>{{post.telephone}}</li>
              <li><span>Kosten</span>{{post.cost}}</li>
              <li><span>Url</span>{{post.url}}</li>
            </ul>
          </div>
        </div>
        <div class="media-right">
          <p class="image is-5by3">
            <img :src="post.image" style="height: 200px" />
            <b v-for="tag in post.tags" :key="tag">{{ tag }}</b>
          </p>
          <p v-if="post.file">
            <a :href="post.file" target="_blank">PDF anzeigen</a>
          </p>
        </div>
      </article>
    </fieldset>
  </div>
</template>

<script>

export default {
  name: 'Post',
  props: {
    post: {
      type: Object,
      required: false
    }
  }
}
</script>


<style scoped lang="scss">
@import '@/assets/styles/main.scss';

.frame {
  margin: 25px 15px 15px 15px;
  border: 1.5px;
  border-style: solid;
  border-color: $primaryBorder;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: $primaryBorder;
}

.media {
  padding: 20px;
  // padding-bottom: 35px;
  background-color: rgb(252, 252, 252);
  height: 100%;
  min-width: 20%;
  font-family: Arial, Helvetica, sans-serif;
}

.media-right {
  min-width: 40%;
}

.content {
  h1 {
    color: $Red;
    margin-bottom: 5px;
    font-weight: 300;
    font-size: 1.1em;
  }
  h3 {
    color: $GreyLight;
    margin-top: 5px;
    margin-bottom: 5px;
    font-weight: 300;
    font-size: 0.9em;
  }
  p {
    margin-top: 16px;
    color: $GreyBlack;
    font-size: 0.7em;
  }
}
    // .tags {
    //   background-color: $primary;
    //   margin: 2px;
      
    // }

.button {
  background-color: $primaryLight;
  color: $white;
}

.detail-list {
  list-style-type: none;
  color: $GreyBlack;
  font-size: 0.7em;
}

.detail-list span{
  background-color: $primaryLight;
  margin-right: 5px
}
</style>
